import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import useAuth from 'src/hooks/useAuth';
import axiosInstance from 'src/utils/axios';

export interface InvalidGLCodeResponseItem {
  glCdId: number;
  glCode: string;
  description: string;
  companyName: string;
  companyId: number;
  propertyNumber: string;
}

const useGetInvalidGLCodesApi = () => {
  const { companyId } = useAuth();
  const call = useCallback(
    async (request?: { glMasks?: string[]; glMaskRequired?: boolean }) => {
      const response = await axiosInstance.post<InvalidGLCodeResponseItem[]>(
        api.getInvalidGLCodes,
        {
          companyId,
          glMasks: request?.glMasks,
          setGlMask: request?.glMaskRequired,
        }
      );
      return response.data;
    },
    [companyId]
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    getInvalidGLCodes: execute,
    isGettingInvalidGLCodes: isLoading,
  };
};

export default useGetInvalidGLCodesApi;
